export default "__VITE_ASSET__ee400605__"